import { render } from "./AlertModalTemplate.vue?vue&type=template&id=09ea948e&scoped=true"
import script from "./AlertModalTemplate.vue?vue&type=script&lang=js"
export * from "./AlertModalTemplate.vue?vue&type=script&lang=js"

import "./AlertModalTemplate.vue?vue&type=style&index=0&id=09ea948e&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ea948e"]])

export default __exports__